import { ReactNode } from "react";
import { Button, Tooltip } from "@mui/material";

export function FeatureToggleGreyOut(props: { featureActive: boolean; children: ReactNode; disabledReason?: string }) {
  const { featureActive, children, disabledReason } = props;
  const className = featureActive ? "feature-toggle" : "feature-toggle feature-toggle--disabled";

  const disabledContent = () => (
    <div onClick={(e) => e.stopPropagation()} className={className}>
      {children}
    </div>
  );

  if (disabledReason) {
    return (
      <Tooltip title={disabledReason}>
        {/* Button is meant to wrap the disabled content on purpose (disabling interaction) */}
        <Button aria-label={"Disabled"} color="primary" size="large">
          {disabledContent()}
        </Button>
      </Tooltip>
    );
  }
  return disabledContent();
}
